const actions = [
  'USER_LOGIN',
  'USER_LOGIN_BEGIN',
  'USER_LOGIN_SUCCESS',
  'USER_LOGIN_FAIL',
  'USER_IMPERSONATE_BEGIN',
  'USER_IMPERSONATE_END',

  'USER_CREATE_SUCCESS',
  'USER_VERIFY_SUCCESS',

  'SEND_VERIFICATION_EMAIL_BEGIN',
  'SEND_VERIFICATION_EMAIL_SUCCESS',
  'SEND_VERIFICATION_EMAIL_FAIL',

  'USER_LOGOUT',

  'USER_PROFILE_LOAD',
  'USER_PROFILE_LOADED',
  'USER_PROFILE_ERROR',

  'USER_CHANNELS_LOAD',
  'USER_CHANNELS_LOADED',
  'USER_CHANNELS_ERROR',

  'CHANNEL_ACASTS_LOAD',
  'CHANNEL_ACASTS_LOADED',
  'CHANNEL_ACASTS_ERROR',

  'TOAST_EMIT',
  'TOAST_DISMISS',
  'TOAST_DISMISS_ACTIVE',

  'MODAL_EMIT',
  'MODAL_DISMISS',
];

export default Object.freeze(
  actions.reduce(
    (acc, next) => ({
      ...acc,
      // eslint-disable-next-line object-shorthand
      [next]: next,
    }),
    {}
  )
);
